import { z } from 'zod';
import { Country } from '@trnsact/trnsact-shared-types';

const trimmedStr = z.string().trim();
const trimmedReqStr = z.string().trim().min(1, { message: 'Required field' });

const selectOptionSchema = z.array(z.string());

export const salesCenterFormSchema = z.object({
  name: trimmedReqStr,
  description: trimmedStr,

  equipment: z.object({
    type: selectOptionSchema,
  }),

  customer: z
    .object({
      type: selectOptionSchema,
      paymentType: selectOptionSchema,
    })
    .partial(),

  address: z.object({
    country: z.nativeEnum(Country),
    zip: z.array(trimmedStr).optional(),
    city: z.array(trimmedStr).optional(),
    state: selectOptionSchema.optional(),
    county: z.array(trimmedStr).optional(),
    province: selectOptionSchema.optional(),
    postalCode: z.array(trimmedStr).optional(),
  }),

  charges: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      isTaxable: z.boolean(),
      description: trimmedStr,
      amountType: trimmedReqStr,
      isEquipmentLvl: z.boolean(),
    })
  ),

  taxes: z.array(
    z.object({
      type: trimmedStr,
      amount: z.number(),
      name: trimmedReqStr,
      description: trimmedStr,
      amountType: trimmedReqStr,
      isEquipmentLvl: z.boolean(),
      isTaxable: z.boolean().optional(),
    })
  ),
});

export type DealSheetFormValues = z.infer<typeof salesCenterFormSchema>;
